module.exports = __webpack_public_path__ + "assets/img/0.a7b2ba29.png";